import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, HostListener, OnDestroy, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Chart from 'chart.js';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issues-billed-in-sla-chart',
    template: '<canvas id="basechart"  #basechart *ngIf="data && data.length > 0; else noData"></canvas><ng-template #noData><p class="text-center">No data available</p></ng-template>',
    styles: [`:host { width:90%; position: relative; display:block; }`]

})
export class IssuesBilledInSlaChartComponent implements OnDestroy, AfterViewInit {

    @ViewChildren('basechart') basechart: any;
    chart: any;
    subscriptions: any[] = [];
    debounceTimeout = 2000;
    debounceId: any;
    consumerId: string;
    polarAreaData: any;
    clientId: number;
    dataNotBeyondEmergency: any[] = [];
    dataNotUsingOverCredit: any[] = [];
    dataUsingOverCredit: any[] = [];
    data: any[] = [];
    labels: any[] = [];
    colors: any[] = [];
    pipe: DatePipe = new DatePipe('en_GB');
    siteId: number;

    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router) { }

    ngAfterViewInit(): void {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {
        this.clientId = this.route.parent.snapshot.params['clientId'];
        if (this.clientId == null || this.clientId == undefined)
            this.clientId = this.route.parent.parent.snapshot.params['clientId'];

        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.issueService.getIssuesBilledInSlaSummary(this.clientId, this.siteId).then(
            result => {
                this.data = [];
                this.labels = [];

                if (!result) {
                    this.createChart();
                    return;
                }

                // billed on time
                if (result.billInLatestSla > 0) {
                    this.data.push(result.billInLatestSla);
                    this.labels.push('Billed on time')
                    this.colors.push('#93c01f');
                }
                
                // no. bill in latest period
                if (result.noBillInLatestSla > 0) {
                    this.data.push(result.noBillInLatestSla);
                    this.labels.push('Billed late');
                    this.colors.push('#FFC000');
                }

                // no. bill in latest sla
                if (result.noBillInLatestPeriod > 0) {
                    this.data.push(result.noBillInLatestPeriod);
                    this.labels.push('Not billed as expected')
                    this.colors.push('#c82b2b');
                }

                this.createChart();
            });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.debounceId) {
            clearTimeout(this.debounceId);
        }
    }

    private getChartConfig(): any {
        let config = {
            type: 'doughnut',
            options: {
                rotation: 1 * Math.PI,
                circumference: 1 * Math.PI,
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    backgroundColor: '#ffffff',
                    titleFontColor: '#153954',
                    bodyFontColor: '#153954',
                    borderWidth: 2,
                    borderColor: '#009aa3'
                },
                maintainAspectRatio: true,
                legend: {
                    display: true
                },
                scales: {
                    xAxes: [{
                        display: false,
                        scaleLabel: {
                            display: false,
                            labelString: 'Amount Days',
                            fontSize: 15,
                        },
                    }],
                    yAxes: [
                        {
                            display: false,
                            scaleLabel: {
                                display: false,
                                labelString: 'Amount',
                                fontSize: 15,
                                fontStyle: "bold",
                            },
                        },
                    ]

                }
            }
        }

        return config;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.createChart();
    }

    createChart() {
        if (this.chart != null) this.chart.destroy();
        if (!this.basechart) return;

        let datasets = [] as any;

        datasets.push({
            data: this.data,
            backgroundColor: this.colors,
            pointRadius: 3,
            borderWidth: 2,
            pointHoverRadius: 8,
            pointHitRadius: 10,
            borderColor: this.colors,
            pointBorderColor: this.colors,
            pointBackgroundColor: this.colors,
            pointHoverBackgroundColor: this.colors,
            pointHoverBorderColor: this.colors
        });

        let config = this.getChartConfig();
        let chartConfiguration: Chart.ChartConfiguration = {
            type: config.type,
            options: config.options,
            data: {
                datasets: datasets,
                labels: this.labels,
            }
        };

        if (this.debounceId) {
            window.clearTimeout(this.debounceId);
        };

        this.debounceId = window.setTimeout(() => {
            if (this.chart != null) this.chart.destroy();
            if (!this.basechart || !this.basechart.first) return;
            let ctx = this.basechart.first.nativeElement;
            this.chart = new Chart(ctx, chartConfiguration);
        }, this.debounceTimeout);
    }
}
